module.exports = __webpack_public_path__ + "img/ctrl-bwecp-stub-up--i.6a858f6e.svg";